import { Text } from '@cinch-labs/design-system'
import Image from 'next/legacy/image'
import { ContentSectionProps as ConstellationSectionProps } from '@cinch-nx/landing-ui-shared'

import styles from './constellation.module.css'

export const ConstellationSection: React.FC<ConstellationSectionProps> = (
  blok,
) => {
  const { body, image } = blok

  return (
    <section className={styles.wrapper}>
      {image?.filename ? (
        <div className={styles.imageWrapper}>
          <Image
            src={image.filename}
            alt={image.alt ?? undefined}
            layout="fill"
          />
        </div>
      ) : null}

      <Text className={styles.body}>{body}</Text>
    </section>
  )
}

export default ConstellationSection
